import { render, staticRenderFns } from "./PerformanceByArea.vue?vue&type=template&id=57338019&"
import script from "./PerformanceByArea.vue?vue&type=script&lang=js&"
export * from "./PerformanceByArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports